import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { ErrorPage } from 'common';
import { fetchNotFoundErrorPage } from './NotFoundErrorPageSlice';
import { NotFoundErrorPageContentSelector } from './NotFoundErrorPageContentSelector';

export function useNotFoundErrorPage(): AbstractContentState<ErrorPage> {
    return useCmsContent(fetchNotFoundErrorPage, NotFoundErrorPageContentSelector);
}
